<div class="adm-page">
  <header class="adm-page__header">
    <div class="adm-page__header-left">
      <div class="adm-page__icon">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      </div>
      <div>
        <h1 class="adm-page__title">Agents</h1>
        <p class="adm-page__desc">Gérez les agents de votre application.</p>
      </div>
    </div>
    <app-ui-button
      label="Ajouter un agent"
      variant="primary"
      size="md"
      iconLeft="add_circle_outline"
      type="button"
      routerLink="add"
    ></app-ui-button>
  </header>

  <div class="adm-card">
  @if (isLoading) {
    <div class="adm-loader-wrapper">
      <app-loaderIntervantion [isLoading]="isLoading" [rows]="6"></app-loaderIntervantion>
    </div>
  } @else {
    <div class="adm-card__toolbar">
      <div class="adm-card__toolbar-left">
        <span class="adm-badge">{{ entities.length }}</span>
        <span class="adm-card__count">agent{{ entities.length > 1 ? 's' : '' }} enregistré{{ entities.length > 1 ? 's' : '' }}</span>
      </div>
    </div>

    @if (!entities.length) {
      <div class="adm-empty">
        <div class="adm-empty__icon">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
        </div>
        <p class="adm-empty__title">Aucun agent</p>
        <p class="adm-empty__hint">Commencez par en ajouter un en cliquant sur le bouton ci-dessus.</p>
      </div>
    } @else {
      <app-ui-table [columns]="tableEntities" [data]="entities" [actions]="rowActions"/>
    }
  }
</div>

  <ng-template #rowActions let-item="item">
    <div class="adm-row-actions">
      <app-ui-button
        iconOnly="edit"
        variant="ghost"
        size="sm"
        ariaLabel="Modifier"
        type="button"
        [routerLink]="[
          '/',
          routeAlias.administration.home,
          routeAlias.administration.agent.home,
          routeAlias.administration.agent.edit,
          item.id,
        ]"
      ></app-ui-button>
      <app-ui-button
        iconOnly="delete"
        variant="danger"
        size="sm"
        ariaLabel="Supprimer"
        type="button"
        (clicked)="openDeleteConfirm(item)"
      ></app-ui-button>
    </div>
  </ng-template>
</div>

<app-confirm-dialog
  [isVisible]="showDeleteConfirm"
  [itemLabel]="selectedItemLabel"
  [isLoading]="deleteLoading"
  (confirmed)="confirmDelete()"
  (cancelled)="cancelDelete()"
></app-confirm-dialog>
